import { render, staticRenderFns } from "./ItemsTypeahead.vue?vue&type=template&id=b45f64d2&scoped=true&"
import script from "./ItemsTypeahead.vue?vue&type=script&lang=js&"
export * from "./ItemsTypeahead.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTypeahead.vue?vue&type=style&index=0&id=b45f64d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45f64d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b45f64d2')) {
      api.createRecord('b45f64d2', component.options)
    } else {
      api.reload('b45f64d2', component.options)
    }
    module.hot.accept("./ItemsTypeahead.vue?vue&type=template&id=b45f64d2&scoped=true&", function () {
      api.rerender('b45f64d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemsTypeahead.vue"
export default component.exports